/**
@author: Nikhil 

jvPrettyTime
============
@desc: Used to show a pretty time stamp using moment js.
@usage: <div class="widget-timestamp small dark-sec" jv-pretty-time time="lastUpdated" display='time-from' ng-if="lastUpdated" ng-model="lastUpdated">{{lastUpdated}}</div>
@params: 
time: Time in epoch format
display: time-from/ time-to . Used to calculate time from or time-to a moment in time.
auto-update: To constantly update the UI as time goes by or not
updateFrequency: How often should it update the UI in milliseconds. Defaults to a mninute ie 60000ms
 **/

angular.module('jv.Common.Directives.jvPrettyTime', [])

.directive('jvPrettyTime',['$interval',function($interval){
        var directiveDefinitionObject = {
            scope:{
                time:'=',
                display:'@',
                autoUpdate:'@',
                updateFrequency:'@'
            },
            require: 'ngModel',
            controller: function($scope, $element){

            },
            link: function($scope, elm, attrs, ngModel){
                //set moment language for i18n support
                moment.locale(_jvselfUser.locale.language);

                //fetchTodayInUsersTimeZone
                var fetchTodayInUsersTimeZone =  function() {
                    var d = new Date();
                    var dateInTime = d.getTime();
                    var userTimeZone = _jvselfUser.locale.timezone;
                    var momentObject = moment.tz(dateInTime,userTimeZone).format();
                    var localDate = momentObject.split('T')[0];
                    localDate = localDate.split('-')[2];
                    d.setDate(localDate);
                    return d;
                };

                if(!$scope.timeStampValue){
                    if($scope.time){
                        //if time stamp provided use that value
                        $scope.timeStampValue = angular.copy($scope.time);
                    }else{
                        //else time stamp is whatever the time is now
                        //We want to find the lastupdated time relative to when the user last reloaded the browser . So use new Date() here.
                        //var d = fetchTodayInUsersTimeZone();
                        var d = new Date();
                        $scope.timeStampValue = angular.copy(d.getTime());
                    }
                }
                
                /** computeTime computes preety time using moment 
                    @params 
                    timeStamp in epoch format 
                    display Type time-from/time-to
                    @returns preetyTime
                **/
                var computeTime = function(updatedTime,display){
                    //var today  = fetchTodayInUsersTimeZone();
                    //We want to find the lastupdated time relative to when the user last reloaded the browser . So use new Date() here.
                    var today  = new Date();
                    var lastUpdatedTimeObject  = new Date(updatedTime);
                    var year = lastUpdatedTimeObject.getFullYear();
                    var month = lastUpdatedTimeObject.getMonth();
                    var date = lastUpdatedTimeObject.getDate();
                    var hours  = lastUpdatedTimeObject.getHours();
                    var minutes  = lastUpdatedTimeObject.getMinutes();
                    var moment_date = moment(today);
                    var result = '';

                    if(display==='time-from'){
                        var timeStampString = i18n['TIME_FROM'];
                        var timeValue = moment_date.from([year,month,date,hours,minutes],true);
                        if(timeStampString && timeValue) {
                        	result = timeStampString.format(timeValue);
                        }
                    }else if(display==='time-to'){
                        result = 'in a '+moment_date.to([year,month,date,hours,minutes],true);
                    }
                    return result;
                };

                $scope.result = computeTime($scope.timeStampValue, $scope.display);
                ngModel.$setViewValue($scope.result);

                //if autoupdate is set update time every updateFrequency seconds
                if($scope.autoUpdate === 'true'){
                    //default updateFrequency value if not provided
                    if(!$scope.updateFrequency){
                        $scope.updateFrequency = 60000;
                    }
                    //keep updating the UI every updateFrequency seconds
                    $interval(function(){
                        $scope.result = computeTime($scope.timeStampValue, $scope.display);
                        ngModel.$setViewValue($scope.result);
                    },$scope.updateFrequency);
                }
                
            }
        };
        return directiveDefinitionObject;
}]);
